import { NgModule } from '@angular/core';
import {
  Routes,
  RouterModule,
  UrlSegment,
  UrlMatchResult,
  UrlSegmentGroup,
  Route
} from '@angular/router';
import { AccessDeniedComponent } from './modules/category/components/access-denied/access-denied.component';
import { WrapperComponent } from './modules/shared/components/wrapper/wrapper.component';
import { ExchangeResolverService } from './modules/shared/services/resolver/exchange-resolver.service';
import { ProfileResolverService } from './modules/shared/services/resolver/profile-resolver.service';
import { StoreDetailService } from './modules/shared/services/resolver/store-detail.service';
import { WalletBalanceService } from './modules/shared/services/resolver/wallet-balance.service';
import { AccessDeniedGuard } from './modules/shared/services/guard/access-denied.guard';
import { StoreGroupResolverResolver } from './modules/shared/services/resolver/store-group-resolver.resolver';
import { StoreRegionService } from './modules/shared/services/store-region.service';
import { InvalidRouteComponent } from './modules/shared/components/invalid-route/invalid-route.component';
import { InvalidRouteService } from './modules/shared/services/invalid-route.service';

export function countryCodeMatcher(
  segments: UrlSegment[],
  _group?: UrlSegmentGroup,
  _route?: Route
): UrlMatchResult | null {
  if (!segments.length) return null;
  const first = segments[0].path.toLowerCase();
  if (/^[a-z]{2}$/.test(first)) {
    return { consumed: [segments[0]], posParams: { cc: segments[0] } };
  }
  return null;
}

const childStacks = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/category/category.module').then(
            (m) => m.CategoryModule
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/product/product.module').then(
            (m) => m.ProductModule
          ),
        resolve: [WalletBalanceService],
      },
    ],
  },
  {
    path: 'authenticate',
    loadChildren: () =>
      import('./modules/authenticate/authenticate.module').then(
        (m) => m.AuthenticateModule
      ),
  },
];

const parentResolvers = [ExchangeResolverService, ProfileResolverService, StoreGroupResolverResolver];

const routes: Routes = [
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AccessDeniedGuard],
  },
  {
    path: 'invalid',
    component: InvalidRouteComponent,
  },

  {
    matcher: countryCodeMatcher,
    component: WrapperComponent,
    // canActivate: [InvalidRouteService],
    children: [
      {
        path: '',
        children: childStacks,
        resolve: parentResolvers,
      },
    ],
    resolve: [StoreDetailService, StoreRegionService],
    runGuardsAndResolvers: 'always',
  },

  {
    path: '',
    component: WrapperComponent,
    // canActivate: [InvalidRouteService],
    children: [
      {
        path: '',
        children: childStacks,
        resolve: parentResolvers,
      },
    ],
    resolve: [StoreDetailService, StoreRegionService],
  },

  { path: '**', redirectTo: '/invalid', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'legacy',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
